module.exports = __webpack_public_path__ + "static/media/20.770f6e16.jpg";